/* eslint-disable camelcase */
import { Backend } from '@/_axios';

export default {
  list(page, filter) {
    return Backend.post('/api/jira/project/', { ...{ page: page }, ...{ filter: filter } });
  },
  changeProjectImport(projectId, isActive) {
    return Backend.put('/api/jira/project/change-import', { id: projectId, jira_import_enabled: isActive });
  },
  listIssues(page) {
    return Backend.get('/api/jira/issues/', { params: { page } });
  },
  searchIssues(searchParams) {
    return Backend.post('/api/jira/issues/search', { params: searchParams });
  },
  projectIssues({project_key, without_ignore_progress = false}) {
    return Backend.post(`/api/jira/project/${project_key}/issues`, { without_ignore_progress });
  },
  jiraIssue(issue) {
    return Backend.get(`/api/jira/issues/${issue}/`);
  },
  jiraIssueSubtasks(issue) {
    return Backend.get(`/api/jira/issues-subtasks/${issue}/`);
  },
  jiraProjectsPushUpdate(projectId) {
    return Backend.put('/api/jira/project/push-import', { id: projectId });
  },
  jiraProjectsResetEntities(projectId) {
    return Backend.put('/api/jira/project/reset-project-entities', { id: projectId });
  },

  getEndDateProgress({ jira_key }) { // project jira key
    return Backend.get(`/api2/project/${jira_key}/end-date-progress`);
  },
  setEndDateProgress(data) { // project jira key
    return Backend.post(`/api2/project/${data.jira_key}/end-date-progress`, data);
  },

  employeeInfo({ id_or_email, signal = null }) {
    return Backend.get(`/api2/employees/info/${id_or_email}`);
  },
  employees({ params, signal = null }) {
    return Backend.get('/api2/employees/', { signal, params });
  },
  employeeEdit({ id, signal = null }) {
    return Backend.get(`/api2/employees/${id}/edit`);
  },
  employeeUpdate({ data }) {
    return Backend.put(`/api2/employees/${data.id}`, data);
  },
  employeeRates({ id, params, signal = null }) {
    return Backend.get(`/api2/employees/${id}/rates`, { signal, params });
  },
  employeeRateAdd({ id, data, signal = null }) {
    return Backend.post(`/api2/employees/${id}/rates`, data, { signal });
  },

  getListForAutocomplete(search) {
    return Backend.post(`/api/jira/issues/list-for-autocomplete`, { search });
  },

};
